<app-image-upload-overlay (image$)="onImageUploaded($event)">
  <form odxForm [formGroup]="imageForm" class="container scroll h-100 padding-24">
    <!-- prettier-ignore -->
    @if (images.length === 0) {
      <h6 class="odx-subtitle-6" i18n="@@imageUpload.noImageYet">Sie haben noch keine Fotos hinzugefügt.</h6>
    }
    <div odxLayout="grid 3@desktop 4@tablet 6@phone" class="mb-36">
      @for (image of images; track image) {
        <app-new-project-file-card
          i18n-title="@@imageUpload.newImage"
          title="Neues Foto"
          [fileName]="image.imageMetadata.name"
          [fileUrl]="image.previewUrl"
          (delete$)="onDelete(image.imageMetadata)"
          (submit$)="onCardSubmit($event, image.imageMetadata)"
          #imageCard
        ></app-new-project-file-card>
      }
    </div>
  </form>
</app-image-upload-overlay>
